<div class="append-container" style="height: 30px;" #container></div>
<form class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
    <fieldset class="k-form-fieldset">
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="refLocal" [text]="customMsgService.translate('local')"> </kendo-label>
            <kendo-dropdownlist formControlName="refLocal" textField="nome" valueField="id" [defaultItem]="placeHolder"
                formControlName="refLocal" [data]="listItemsLocais" #refLocal required>
            </kendo-dropdownlist>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('local') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="nome" [text]="customMsgService.translate('name')"> </kendo-label>
            <kendo-textbox formControlName="nome" [clearButton]="true" #nome required> </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('name') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="numeroDeSerie" [text]="customMsgService.translate('numeroDeSerie')">
            </kendo-label>
            <kendo-textbox formControlName="numeroDeSerie" [clearButton]="true" #numeroDeSerie required>
            </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('numeroDeSerie') }} {{ customMsgService.translate('isRequired') }}
            </kendo-formerror>
        </kendo-formfield>

        <br />
        <div class="card-component">
            <kendo-grid #grid [kendoGridBinding]="gridView">
                <ng-template kendoGridToolbarTemplate>
                    <kendo-grid-spacer></kendo-grid-spacer>
                    <button kendoButton (click)="addModulo()" [title]="customMsgService.translate('btnAdicionar')"
                        icon="add" themeColor="primary">
                    </button>
                </ng-template>

                <kendo-grid-column field="nomeModeloModulo" [width]="160" [editable]="false"
                    [title]="customMsgService.translate('modulos')">
                </kendo-grid-column>

                <kendo-grid-column field="megaLocker" title="{{customMsgService.translate('optionEletronica')}}"
                    [width]="40">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span *ngIf="dataItem.megaLocker === true">MegaLocker</span>
                        <span *ngIf="dataItem.megaLocker === false">Locker</span>
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column title="" [width]="15">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button kendoGridEditCommand icon="delete" [title]="customMsgService.translate('btnEliminar')"
                            (click)="deleteModelo(dataItem)" themeColor="error"></button>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
        <hr />
        <div class="k-form-buttons">
            <button kendoButton (click)="cancelChanges()">
                {{ customMsgService.translate('cancel') }}
            </button>
            <button kendoButton [primary]="true" [disabled]="formGroup.invalid || formGroup.pristine"
                (click)="saveChanges()">
                {{ customMsgService.translate('saveChanges') }}
            </button>
        </div>
    </fieldset>
</form>